<template>
  <div class="main">
    <vue-headful title="ITT流体技术" description="ITT流体技术" />
    <img class="logo" src="../assets/download/logo2.png" alt="" />
    <div class="container">
      <div class="content" v-for="(item, index) in categories" :key="index" @click="onClick(item)">
        <div class="left">
          <div class="left-top">{{ item.name }}</div>
          <div class="left-bottom">
            <div class="brand" v-for="(brand, idx) in item.brands" :key="idx">
              <template v-if="brand == 'SPX FLOW'">
                <p>{{ brand }}</p>
              </template>
              <template v-else>
                <img src="../assets/download/row.png" alt="" />
                <p>{{ brand }}</p>
              </template>
            </div>
          </div>
        </div>
        <img class="right" src="../assets/download/right-row.png" alt="" />
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getCategories } from "@/api/request";
export default {
  name: "download-query",
  data() {
    return {
      categories: [],
      user: {},
      list: [
        {
          name: "阀门",
          apv: true,
        },
        {
          name: "泵",
          apv: true,
          // icon: require("../assets/download/waukesha.png")
          text: "Waukesha Cherry-Burrell",
        },
        {
          name: "均质机",
          apv: true,
          // icon: require("../assets/download/waukesha.png")
        },
        {
          name: "分离机",
          apv: false,
          // icon: require("../assets/download/seital.png")
          text: "Seital Separation",
        },
        {
          name: "混料机",
          apv: true,
        },
        {
          name: "换热器",
          apv: true,
          // icon: require("../assets/download/waukesha.png")
          text: "Waukesha Cherry-Burrell",
        },
        {
          name: "喷雾干燥系统",
          apv: false,
          // icon: require("../assets/download/anhydro.png")
          text: "Anhydro",
        },
        {
          name: "液体处理系统",
          apv: true,
        },
        {
          name: "油脂加工系统",
          apv: false,
          // icon: require("../assets/download/gerstenberg.png")
          text: "Gerstenberg Schröder",
        },
      ],
    };
  },
  methods: {
    onClick(item) {
      console.log(item.id);

      this.$router.push(`/brandnew/${item.id}`);
      // if (item.category_downloads && item.category_downloads.length > 0) {
      //   window.location.href = `https://itt-ft.effective-wechat.com/web/${item.slug}`;
      // }
    },
  },
  async mounted() {
    try {
      // await getProfile();

      const res = await getCategories();
      this.categories = res.data;
    } catch (err) {
      console.log(err);
    }
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  .logo {
    width: 100vw;
    height: calc(100vw * (195 / 750));
    margin-top: calc(-100vw * (12 / 750));
  }
  .container {
    box-sizing: border-box;
    background: url("https://itt-ft.effective-wechat.com/spx1/img/bg.png") no-repeat;
    background-size: cover;
    width: 100vw;
    // height: calc(100vw * (1420 / 750));
    // height: calc(100vw * (1320 / 750));
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 22.5px;
    padding-bottom: 19px;
    .content {
      box-sizing: border-box;
      width: calc(100vw * (666.4 / 750));
      // height: calc(100vw * (666.4 / 750) * (120.9 / 666.4));
      background: #ffffff;
      box-shadow: 0.5px 3.5px 19.5px 0px rgba(12, 74, 89, 0.1);
      border-radius: 10px;
      margin-bottom: 13.5px;
      padding: 13.5px 10px 10px 21px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-content: space-between;
        .left-top {
          font-size: 18px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #1d4f48;
          line-height: 17.5px;
          margin-bottom: 10px;
        }
        .left-bottom {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          width: 100%;
          max-width: 70vw;
          // .apv {
          //   width: calc(100vw * (81 / 750));
          //   height: calc(100vw * (81 / 750) * (20 / 81));
          //   margin-right: 12.5px;
          // }
          // .icon {
          //   height: calc(100vw * (22 / 750))
          // }
          .brand {
            display: flex;
            align-items: center;
            margin-right: 12.5px;
            white-space: nowrap;
            img {
              height: 10px;
              margin-right: 4px;
            }
            p {
              font-size: 14px;
              font-weight: 600;
              color: #666;
              margin: 0;
              line-height: 20px;
            }
          }
          .brand:last-child {
            // width: 180px;
            margin-right: 0;
          }
        }
      }
      .right {
        width: calc(100vw * (55 / 750));
        height: calc(100vw * (55 / 750));
      }
    }
  }
  .footer {
    margin-top: 2px;

    font-family:
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Roboto,
      Helvetica Neue,
      Arial,
      sans-serif,
      Apple Color Emoji,
      Segoe UI Emoji,
      Segoe UI Symbol,
      Noto Color Emoji;
    border-bottom: 15px solid #686767;
  }

  .footer-top {
    height: 10px;
    background: url("../assets/sep.png") repeat-x;
  }

  .footer-content {
    display: flex;
    margin: 30px 15%;
  }

  .qr {
    flex: 0 1 30%;
  }

  .qr img {
    width: 100px;
  }

  .info {
    flex: 1 0 70%;
    font-size: 10px;
    text-align: left;
    padding-left: 10px;
    margin-top: 3px;
    box-sizing: border-box;
  }

  h5 {
    font-size: 11px;
    color: #1ea135;
    margin: 0;
    margin-top: 2px;
  }

  .info-p {
    margin: 0;
    // line-height: 16px;
    font-size: 10.5px;
    font-weight: 400;
    color: rgba(62, 62, 62, 1);
  }

  .first-p {
    margin-top: 14px;
  }
}
</style>
